import { NavLink } from "react-router-dom";
import vk from "../../staticPages/img/vk.png";
import inst from "../../staticPages/img/inst.png";

import "./style.css";

export const Footer = () => {
  return (
    <footer className="app_footer">
      <div className="footer_content">
        <nav className="footer_nav">
          <NavLink to="/catalog">Каталог</NavLink>
          <NavLink to="/about">Контакты</NavLink>
          <NavLink to="/reviews">Отзывы</NavLink>
          <NavLink to="/delivery">Доставка и оплата</NavLink>
        </nav>

        <div className="footer_info">
          © Cvetochnaya Lavka, Иркутск {new Date().getFullYear()}г
        </div>

        <div className="footer_socNetwork">
          <a
            title="Мы Вконтакте"
            href="https://vk.com/club226331760"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={vk} alt="Вконтакте" />
          </a>
          <a
            title="Мы в Instagram"
            href="https://www.instagram.com/cvetochnaya_lavka_"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={inst} alt="Instagram" />
          </a>
        </div>
      </div>
    </footer>
  );
};
